module.exports = __webpack_public_path__ + "img/consultorio-juridico.13ba5832.png";